import { put, select, takeLatest } from 'redux-saga/effects';
import { TaskId } from 'api/models';
import { TaskAPI } from 'api/tasks';
import { FetchStatus } from 'data/core';
import { selectIsTaskPaneUpdateEnabled } from 'hooks/use-task-pane-update-mini';
import { queryClient } from 'queries';
import { getProjectTasksQueryKey } from 'queries/common';
import { invalidateTaskQuery } from 'utils/invalidate-task-query';
import { boardTaskSavedAction, saveTaskDetailSaga, updateTaskSagaAction, updateTaskDatesSagaAction, updateTaskTimelineSagaAction, updateTaskRecordWithLatestDataSagaAction } from '../actions';
import { selectTask } from '../selectors';
import { saveTasks } from '../slice';
function* updateTaskSaga(action) {
    const { payload } = action;
    if (payload) {
        const { taskId, projectId, data, options } = payload;
        const oldTaskState = yield select(selectTask(TaskId(projectId, taskId)));
        if (options === null || options === void 0 ? void 0 : options.skipApiCall) {
            return;
        }
        try {
            const selectedTask = yield select(selectTask(TaskId(projectId, taskId)));
            const isEnabled = yield select(selectIsTaskPaneUpdateEnabled);
            const updatedTask = isEnabled ? (yield TaskAPI.updateTaskMini(projectId, taskId, data, options === null || options === void 0 ? void 0 : options.isSync), selectedTask) : yield TaskAPI.updateTask(projectId, taskId, data, options === null || options === void 0 ? void 0 : options.isSync, options === null || options === void 0 ? void 0 : options.actor);
            const newTask = (options === null || options === void 0 ? void 0 : options.refetchGetData) && (yield TaskAPI.getTask(projectId, taskId));
            yield put(updateTaskRecordWithLatestDataSagaAction({
                taskId,
                data: newTask || updatedTask,
                projectId
            }));
            if (options === null || options === void 0 ? void 0 : options.resolveCallback) {
                options.resolveCallback(newTask || updatedTask);
            }
            if (!(options === null || options === void 0 ? void 0 : options.skipStoreUpdate)) {
                yield put(saveTaskDetailSaga(newTask || updatedTask));
            }
            if (!(options === null || options === void 0 ? void 0 : options.skipRefetch)) {
                yield invalidateTaskQuery(taskId);
                queryClient.refetchQueries(getProjectTasksQueryKey([
                    'project_id',
                    projectId
                ]));
            }
            yield put(boardTaskSavedAction({
                taskId,
                projectId
            }));
            if (updatedTask && (options === null || options === void 0 ? void 0 : options.toggleUpdating)) {
                options.toggleUpdating(false);
            }
        } catch (unused) {
            if (oldTaskState) {
                if (options === null || options === void 0 ? void 0 : options.rejectCallback) {
                    options.rejectCallback(oldTaskState);
                }
                yield put(saveTasks({
                    data: [
                        oldTaskState
                    ],
                    fetchStatus: FetchStatus.Loaded
                }));
            }
        }
    }
}
function* updateTaskDatesSaga(action) {
    const { payload } = action;
    if (payload) {
        const { data, options } = payload;
        const { taskId, projectId } = data;
        const oldTaskState = yield select(selectTask(TaskId(projectId, taskId)));
        try {
            const updatedTask = yield TaskAPI.updateTask(projectId, taskId, data);
            if (!(options === null || options === void 0 ? void 0 : options.skipStoreUpdate)) {
                yield put(saveTaskDetailSaga(updatedTask));
            }
        } catch (unused) {
            if (oldTaskState) {
                yield put(saveTasks({
                    data: [
                        oldTaskState
                    ],
                    fetchStatus: FetchStatus.Loaded
                }));
            }
        }
    }
}
export function* watchUpdateTaskSaga() {
    yield takeLatest(updateTaskSagaAction.type, updateTaskSaga);
    yield takeLatest(updateTaskTimelineSagaAction.type, updateTaskSaga);
}
export function* watchUpdateTaskDatesSaga() {
    yield takeLatest(updateTaskDatesSagaAction.type, updateTaskDatesSaga);
}
